import React, { FC, useEffect } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { TspInfo } from '@widgets/tsp-info';
import { FAQ } from '@widgets/faq';
import { SteamStories } from '@widgets/stories';
import { SteamFormSection } from '@widgets/payment';
import { SteamHelp } from '@widgets/help';
import { ScrollWidget } from '@widgets/promo';
import { SbpQrModalDesktop } from '@widgets/sbp-qr-modal';
import { SteamVouchers } from '@widgets/vouchers';
import { SteamPaymentForm } from '@features/payment/payment-form';
import { CommissionDataByServiceIdType } from '@entities/denomination';
import { getFaqForSteamPage } from '@entities/faq';
import { SteamAccountPayee, SteamAccountVoucher } from '@entities/tsp';
import { steamBannerClickGtm, steamPageShowGtm } from '@shared/lib/gtm/redesign';
import { usePartner } from '@shared/lib/partner';
import { withTheme } from '@shared/lib/theme';
import { Text } from '@shared/ui/atoms';
import steamHeroBg from '../assets/steam-hero-bg.jpg';
interface SteamFormPageViewProps {
  h1: string;
  payee: SteamAccountPayee;
  countryVouchers: {
    country: string;
    icon: string;
  }[];
  denominationsByCountry: Record<string, SteamAccountVoucher[]>;
  commissionData: CommissionDataByServiceIdType;
}
const SteamFormPageView: FC<SteamFormPageViewProps> = ({
  h1,
  payee,
  countryVouchers,
  denominationsByCountry,
  commissionData
}) => {
  useEffect(() => {
    steamPageShowGtm();
  }, []);
  return <SteamFormPageViewWrapper>
      <NotScrollableContent>
        <HeroBgImageWrapper>
          <Image src={steamHeroBg} alt="steam" width={1440} height={512} />
        </HeroBgImageWrapper>
      </NotScrollableContent>
      <ScrollableContentWrapper>
        <SteamPaymentForm h1={h1} payee={payee} commissionData={commissionData} renderTspInfo={props => <TspInfo {...props} />} renderStories={() => <SteamStories />} renderPromo={() => <ScrollWidget onBannerClick={steamBannerClickGtm} />} renderPaymentForm={props => <SteamFormSection {...props} />} renderHelp={() => <SteamHelp />} renderQrModal={props => <SbpQrModalDesktop {...props} />} />
        <SteamVouchers countryVouchers={countryVouchers} denominationsByCountry={denominationsByCountry} />
      </ScrollableContentWrapper>
    </SteamFormPageViewWrapper>;
};

// <PaymentForm
//   h1={h1}
//   payee={payee}
//   linkedTsp={linkedTsp}
//   countryVouchers={countryVouchers}
//   denominationsByCountry={denominationsByCountry}
//   servers={servers}
//   hints={hints}
//   renderTspInfo={(props) => <TspInfo {...props} />}
//   renderReplenishmentInfo={(props) => <ReplenishmentInfo {...props} />}
//   renderAccountInfo={(props) => <AccountInfo {...props} />}
//   renderPaymentInfo={(props) => <PaymentInfo {...props} />}
//   renderQrModal={(props) => <SbpQrModalDesktop {...props} />}
// />
// <Spacer space={64} spacetablet={48} spacemob={32} />
// <FAQWrapper>
//   <OldFAQ content={getAccordionDataByTspURL(providerURL)(partner)} />
// </FAQWrapper>

export default SteamFormPageView;
const SteamFormPageViewWrapper = /*#__PURE__*/styled('div')({
  name: "SteamFormPageViewWrapper",
  class: "s1f7ybv7",
  propsAsIs: false
});
const HeroBgImageWrapper = /*#__PURE__*/styled('div')({
  name: "HeroBgImageWrapper",
  class: "hubmczt",
  propsAsIs: false
});
const NotScrollableContent = /*#__PURE__*/styled('div')({
  name: "NotScrollableContent",
  class: "n1kcmnjr",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ScrollableContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ScrollableContentWrapper",
  class: "sl0hf8x",
  propsAsIs: false,
  vars: {
    "sl0hf8x-0": [_exp()]
  }
}));

require("./SteamFormPageView.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SteamFormPageView.tsx");